// src/modules/auth/utils/role.utils.ts

export const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  USER: "USER",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const hasManagePermission = (auth: any): boolean => {
  const role = auth?.user?.role || auth?.role;
  return (
    // role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN || role === ROLES.USER
    true
  );
};
